import { render, staticRenderFns } from "./ClientDeadlinesCalendar.vue?vue&type=template&id=6e492eea&scoped=true"
import script from "./ClientDeadlinesCalendar.vue?vue&type=script&lang=js"
export * from "./ClientDeadlinesCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e492eea",
  null
  
)

export default component.exports